import brand from '@helpers/brand';
import srOnly from '@helpers/srOnly';
import { Layers } from '@helpers/layers';
import { Device, until, from } from '@helpers/media';
import { SitePadding } from '@stories/Components/Global/SiteWide/SiteWide.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import styled from 'styled-components';
const Container = styled.section `
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  align-items: center;
  background: rgba(0, 0, 0, 0.75);
  height: 100%;
  justify-content: center;
  padding: 0 ${SitePadding}px;
  width: 100%;
  z-index: ${Layers.Modal};
`;
const Close = styled.button `
  position: absolute;
  top: -35px;
  left: -5px;
  display: block;
  background: none;
  border: 0;
  transform: scale(1);
  transition: transform 0.1s ease-out;

  > svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  > span {
    ${srOnly}
  }

  &:focus,
  &:hover {
    transform: scale(1.2);
  }

  @media ${until(Device.Desktop)} {
    > svg {
      color: ${brand.white};
    }
  }

  @media ${from(Device.Desktop)} {
    top: 20px;
    left: auto;
    right: 20px;

    > svg {
      width: 15px;
      height: 15px;
    }
  }
`;
const Inner = styled.div `
  position: relative;
  background: ${brand.white};
  margin-top: 30px;
  height: calc(100% - 70px);
  padding: 32px 16px;
  width: 100%;
  text-align: center;

  @media ${from(Device.Tablet)} {
    max-height: 500px;
    max-width: 400px;
  }

  @media ${from(Device.Desktop)} {
    padding: 64px 32px;
  }
`;
const Input = styled.input `
  display: block;
  flex: 1 1 auto;
  width: 100%;
  background: ${brand.greyVeryLight};
  border: 1px solid ${brand.black};
  border-radius: 9px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 24px;
  outline: none;
  padding: 9px 14px;
  transition: border-color 0.15s ease-out;
  margin-bottom: 24px;
`;
const Heading = styled.p `
  ${HeadingStyles.H5Styles}
`;
const Intro = styled.p `
  ${ParagraphStyles.RegularStyles}

  margin-bottom: 24px;
`;
export default {
    Container,
    Close,
    Inner,
    Input,
    Heading,
    Intro,
};
